var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import columns from './columns';
export default __assign(__assign({}, columns), { principalExhibitor: {
        label: 'Expositor principal',
        field: 'principalExhibitor',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    }, facing: {
        label: 'Facing (un.)',
        field: 'facing',
        type: 'general',
        align: 'left',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true,
    }, depth: {
        label: 'Profundidade (un.)',
        field: 'depth',
        type: 'general',
        align: 'left',
        customWidth: 150,
        fixed: false,
        render: true,
        disableOrder: true,
    }, height: {
        label: 'Altura (un.)',
        field: 'height',
        type: 'general',
        align: 'left',
        customWidth: 120,
        fixed: false,
        render: true,
        disableOrder: true,
    }, priceType: {
        label: 'Tipo de precificação',
        field: 'priceType',
        type: 'general',
        align: 'left',
        customWidth: 170,
        fixed: false,
        render: true,
        disableOrder: true,
    }, labelQty: {
        label: 'Qtde. de etiquetas',
        field: 'labelQty',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    }, variations: {
        label: 'Variação',
        field: 'variations',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
        break: true,
    }, beepedBy: {
        label: 'price.audit.beepedBy',
        field: 'beepedBy',
        type: 'general',
        align: 'left',
        customWidth: 350,
        fixed: false,
        render: true,
        disableOrder: true,
    } });
